import { jsx as _jsx } from "react/jsx-runtime";
import { useFrame } from '@react-three/fiber';
import React, { useMemo, memo, useRef, } from 'react';
import { useSRGBColors } from '../hooks/useSRGBColors';
import SpinnerSvg from './assets/spinner.svg';
import Svg from './Svg/Svg';
const Spinner = ({ scale, opacity = 1, position = [0, 0, 0], rotation = [0, 0, 0], color: c = '#FFFFFF', radiansPerFrame = 0.06, renderOrder, 
// depthWrite = false,
raycast }) => {
    const groupRef = useRef(null);
    const zeroPos = useMemo(() => [0, 0, 0], []);
    const color = useSRGBColors(c);
    useFrame(() => {
        if (!groupRef?.current?.rotation)
            return;
        groupRef.current.rotation.z += radiansPerFrame;
    });
    return (_jsx("group", { ref: groupRef, position: position, rotation: rotation, raycast: raycast, children: _jsx(Svg, { name: '', raycast: raycast, color: color, svgUrl: SpinnerSvg, opacity: opacity, position: zeroPos, scale: scale, renderOrder: renderOrder ? renderOrder + 5 : undefined }, 'spinner') }, 'spinner_group'));
};
export default memo(Spinner);
